import { Component, computed, inject } from '@angular/core';
import { SignalsStoreService } from '../signals-store.service';

@Component({
    selector: 'app-privacy-policy',
    imports: [],
    templateUrl: './privacy-policy.component.html',
    styleUrl: './privacy-policy.component.scss'
})
export class PrivacyPolicyComponent {
  #signalsStoreService = inject(SignalsStoreService);
  loading: boolean = false;

  logoVersionNumber = computed(() => this.#signalsStoreService.logoVersionNumber());

}
